<template>
  <!--首页-->
  <tk-container
    :status="status"
    infiniteScroll
    class="container-wrap"
    ref="resetInfiniteScrollHome"
    @refresh="refreshInit"
    :probeType="3"
    @scroll="watchScroll"
    @loadingMore="recommendedProducts"
  >
    <!--头部-->
    <tkui-header
      slot="header"
      class="flex"
      :style="{ backgroundColor: isHeaderColor ? '#cf1613' : 'rgba(255, 255, 255, 0)' + '!important',
       zIndex: 100, paddingTop: statusBarHeight + 'px !important', top: 0 }"
    >
      <tk-flex middle class="flex-header full">
        <!--logo-->
        <div
          class="flex-header-logo p-t-5"
        >
          <tk-image size="contain" :quality="100" :src="liPaoLogo" :width="50" :height="26"></tk-image>
        </div>
        <!--搜索跳转框-->
        <div
          class="flex-header-search fill"
          @click="$push('/common/searchPage')"
          :style="{ backgroundColor: isHeaderColor ? '#eeeeee' : '#fff' + '!important' }"
        >
          <tk-flex middle class="fill">
            <tkui-button class="icon flex-icon m-0 m-l-10">
              <tk-icon size="16" color="#bbb">search</tk-icon>
            </tkui-button>
            <div class="m-l-10">点击搜索</div>
          </tk-flex>
        </div>
        <!--消息提示按钮-->
        <div
          class="text-right m-r-5"
          @click="$push('/common/messageNotification')"
        >
          <tkui-badge :show="tipsStatus">
            <tk-icon size="25" :color="isHeaderColor ? '#fff' : '#fff'">news</tk-icon>
          </tkui-badge>
        </div>
      </tk-flex>
    </tkui-header>
    <!--数据渲染-->
    <div
      class="content-box"
      :style="{ backgroundImage: `url(${bgSrc}) !important`,
       paddingTop: 44 + statusBarHeight + 'px' }"
    >
      <!--轮播图片-->
      <carousel @changeIndex="changeIndex" :banner-image="bannerImage" :width="100" :height="145"></carousel>
      <!--金刚区分类展示-->
      <div class="type-box m-x-12">
        <tk-flex wrap>
          <tk-flex column
                   center
                   style="width: 20%;"
                   class="item m-t-10"
                   v-for="(item, index) in kingKongDistrict"
                   @click.native="toggleClass(item)"
                   :key="`item${index}`"
          >
            <template>
              <tk-avatar class="type-img">
                <tk-image v-if="item.image" replacement :src="item.image" width="49" height="49"></tk-image>
                <tk-image v-else replacement :src="'https://s3.moke.cloud/dianpei/b6db4469-0a21-49ce-ba89-bc1a0791a199.png'" width="49" height="49"></tk-image>
              </tk-avatar>
              <div class="type-text">{{item.name}}</div>
            </template>
          </tk-flex>
        </tk-flex>
      </div>
      <!--活动图片eventPictures-->
      <div class="m-x-12 m-b-10" v-if="eventPictures">
        <div
          class="event-pictures"
          :style="`background-image: url(${eventPictures}) !important`"
          @click="$push('/activity/promotions')"
        >
        </div>
      </div>
      <!--限时抢购-->
      <div class="m-x-12" v-if="limitedTimeSnapping.length">
        <home-class class="m-t-10" :commodity-arr="limitedTimeSnapping" :title="'限时抢购'" :type="'limitedTimeSnapping'" :timeData="timeRule"></home-class>
      </div>
      <!--品牌专场-->
      <div class="m-x-12">
        <card :height="100" class="m-t-10 p-x-12 p-y-8">
          <card-title
            :type="'brandSpecial'"
            :title="'品牌专场'"
            :commodity-arr="brandSpecial"
            :is-more="true"
            :font-size="16"
            :linear-top-color="'#fff'"
            :linear-bottom-color="'#fff'"
          ></card-title>
          <tk-flex wrap gutter="5" v-if="brandSpecial.length">
            <tk-flex
              class="brand-special tk-grid-6"
              middle
              v-for="(s, index) in brandSpecial"
              :key="`brand-special${index}`"
              @click.native="$push({ path: '/commodity/childSpecial', query: { classId: s.category.objectId } })"
              :style="{backgroundImage: `url(${s.bgImage}) !important`}"
            >
              <tk-flex middle column class="tk-grid-6">
                <div
                  style="line-height: 1;"
                  :style="{color: s.color}"
                  class="van-ellipsis p-b-2 font-14"
                >{{s.brandTitle ? s.brandTitle : '暂无品牌标题'}}</div>
                <div :style="{color: s.exColor}" class="font-12 van-ellipsis">{{s.explanation ? s.explanation : '暂无品牌说明'}}</div>
                <div style="width: 44px;height: 20px;" class="m-t-2">
                  <tk-image :src="s.tipsImage" width="44" height="20"></tk-image>
                </div>
              </tk-flex>
              <tk-flex middle right class="text-right tk-grid-6">
                <tk-image :src="s.category.image" width="83" height="83"></tk-image>
              </tk-flex>
            </tk-flex>
          </tk-flex>
          <empty-tips v-else :height="298 - 75" :width="100" :empty-msg="'暂无数据'"></empty-tips>
        </card>
      </div>
      <!--新品上市-->
      <div class="m-x-12" v-if="newProducts.length">
        <home-class class="m-t-10" :commodity-arr="newProducts" :title="'新品上市'" :type="'newProducts'" :timeData="timeRule"></home-class>
      </div>
      <!--热卖榜单-->
      <div class="m-x-12" v-if="hotList.length">
        <card :height="100" class="m-t-10 p-y-8 p-x-12">
          <card-title
            :type="'hotList'" :title="'热卖榜单'"
            :commodity-arr="hotList"
            :is-more="true"
            :font-size="16"
            :linear-top-color="'#fff'"
            :linear-bottom-color="'#fff'"
          ></card-title>
          <tk-flex
            v-if="hotList.length"
            gutter="5"
          >
            <tk-flex
              column
              center
              class="tk-grid-4"
              v-for="(s, index) in hotList"
              @click.native="$push({ path: '/commodity/productDetails', query: { id: s.objectId } })"
              :key="index"
            >
              <div class="class-recommended-img">
                <tk-image
                  class="img-radius class-recommended-image"
                  :src="s.showPictures[0]" width="108" height="108"></tk-image>
                <div class="class-hot-list" :style="{backgroundImage: `url(${s.tipsImage}) !important`}">
                  <div>TOP</div>
                  <div>{{index + 1}}</div>
                </div>
              </div>
              <div
                class="font-14 m-t-2 class-card-black class-card-wrap text-center van-ellipsis"
              >{{s.productTitle}}</div>
              <div v-if="s.oldPrice && judgeTimeRule">
                <div class="class-card-red m-t-2">
                  <span class="font-10">￥</span>{{s.price}}
                  <span class="font-12 m-l-5 class-card-decoration caption">
                    <span class="font-10">￥</span>{{s.oldPrice}}</span>
                </div>
              </div>
              <div v-else class="m-t-2 class-card-red"><span class="font-10">￥</span>{{s.price}}</div>
            </tk-flex>
          </tk-flex>
          <empty-tips v-else :height="207 - 75" :width="100" :empty-msg="'暂无数据'"></empty-tips>
        </card>
      </div>
      <!--促销礼品-->
      <div class="m-x-12 m-t-10" v-if="promotionalGifts.length">
        <linear-card
          class="p-x-12"
          :width="100" :height="50"
          :linear-bottom-color="'#FFFFFF'"
          :linear-top-color="'#ffffff'"
          :font-size="16"
          :is-row-padding="false"
          :commodity-arr="promotionalGifts"
          :type="'promotionalGifts'"
          :title="'推荐商品'"
          :is-more="true"
        >
          <tk-flex wrap class="p-y-8" gutter="5" v-if="promotionalGifts.length">
            <commodity-three-row
              v-for="(s, index) in promotionalGifts"
              :key="index"
              :commodity="s"
              :selling-color="'#999'"
              :selling-bg="'rgba(255, 255, 255, 0)'"
            >
            </commodity-three-row>
          </tk-flex>
          <empty-tips v-else :height="150" :width="100" :empty-msg="'暂无推荐数据'"></empty-tips>
        </linear-card>
      </div>
      <!--购买推荐-->
      <div class="m-x-12" v-if="buyRecommendation.length && !isUpShelf">
        <card :height="50" class="m-t-10 p-x-12 p-y-8">
          <card-title
            :type="'buyRecommendation'"
            :title="'购买推荐'"
            :commodity-arr="buyRecommendation"
            :is-more="true"
            :font-size="16"
            :linear-top-color="'#fff'"
            :linear-bottom-color="'#fff'"
          ></card-title>
          <tk-flex
            gutter="12"
            middle
            v-for="(s, index) in buyRecommendation"
            @click.native="$push({ path: '/common/articleDetail', query: { type: 'buyRecommendation', id: s.objectId } })"
            :key="`buyRecommendation${index}`"
            :class="{'m-t-10': index > 0}"
          >
            <div class="tk-grid-4">
              <div class="content-box-br">
                <tk-image
                  class="content-box-br-img"
                  :quality="100"
                  :src="getArticleImage(s.IntroductionEvent)[0]"
                  height="105"
                >
                </tk-image>
              </div>
            </div>
            <tk-flex column class="tk-grid-8">
              <div class="font-bold font-14 van-ellipsis">{{s.articleTitle}}</div>
              <div class="text-caption content-box-br-html m-t-10 van-multi-ellipsis&#45;&#45;l2" v-html="getArticleText(s.IntroductionEvent)"></div>
            </tk-flex>
          </tk-flex>
        </card>
      </div>
      <!--为你推荐-->
      <infinite-list :title="'为你推荐'" :infinite-list-pad="'p-x-12'" :products-data="getPriceProcessing(recommendedProductsData, judgeTimeRule)" :color="'#000000'"></infinite-list>
    </div>
  </tk-container>
</template>

<script>
import { mapState } from 'vuex'
import cardTitle from '@/components/cardTitle'
import homeClass from '@/components/homeClass'
import carousel from '@/components/carousel'
import linearCard from '@/components/linearCard'
import commodityThreeRow from '@/components/commodityThreeRow'
import { priceProcessing } from '@/assets/help/tool'
// 测试提交
export default {
  components: {
    carousel,
    cardTitle,
    homeClass,
    linearCard,
    commodityThreeRow
  },
  data () {
    return {
      status: 'loading', // 页面状态
      isHeaderColor: false, // 判断头部颜色切换
      liPaoLogo: 'https://s3.moke.cloud/dianpei/82567f41-5763-4149-9bef-82ad1058fd7e.png', // logo图片
      eventPictures: null, // 活动图片
      messageTimer: null, // 轮询消息定时id
      bannerImage: [], // 轮播图数据
      bannerIndex: 0, // 当前轮播图切换图片的索引
      kingKongDistrict: [], // 金刚区功能分类
      limitedTimeSnapping: [], // 限时抢购数据
      timeRule: {}, // 限时抢购时间规则
      brandSpecial: [], // 品牌专场数据
      newProducts: [], // 新品上市数据
      hotList: [], // 热卖榜单数据
      promotionalGifts: [], // 促销礼品数据
      buyRecommendation: [], // 购买文章数据
      recommendedProductsData: [] // 为你推荐商品数据获取
    }
  },
  computed: {
    ...mapState(['statusBarHeight']),
    // 背景图src
    bgSrc () {
      if (!this.bannerImage.length) { return '' }
      return this.bannerImage[this.bannerIndex].backgroundImage
    },
    // 判断抢购时间是否有效
    judgeTimeRule () {
      if (!this.timeRule) return false
      let endSum = new Date(this.timeRule.endTime).getTime()
      let nowSum = new Date().getTime()
      return nowSum - endSum < 0
    },
    // 消息提示状态
    tipsStatus () {
      return !!(this.userInfo && this.userInfo.tipsStatus && this.userInfo.tipsStatus.redShow)
    }
  },
  activated () {
    this.bannerIndex = 0
    this.setStatusBar('light')
    this.messageTimer = setInterval(this.getUpdateMessage, 2000)
  },
  mounted () {
    this.getInit()
  },
  beforeRouteLeave (to, from, next) {
    this.setStatusBar('dark') // 离开还原内容为黑色
    clearInterval(this.messageTimer)
    next(true)
  },
  methods: {
    /**
    * 初始化数据
    * @首页主题背景图
    * @date: 2020/3/12
    */
    async getInit () {
      try {
        await this.getEventPictures() // 获取首页活动图片
        await this.getBannerImage() // 获取轮播图·背景图
        await this.getKingKongDistrict() // 金刚区功能分类 (只获取前10条)
        await this.getLimitedTimeRule() // 获取限时抢购的时间 （只获取1条）
        await this.getLimitedTimeSnapping() // 获取限时抢购数据 （只获取6条）
        await this.getBrandSpecial() // 获取品牌专场类别 （按创建时间最新的4条）
        await this.getNewProducts() // 获取新品上市数据 （按创建时间倒序，只获取6条）
        await this.getHotList() // 获取热卖榜单数据 （按销量倒序，只获取3条）
        await this.getPromotionalGifts() // 获取促销礼品数据 （按创建时间倒序，只获取6条）
        await this.getPurchaseArticle() // 获取购买推荐文章 （按创建时间倒叙获取3条）
        this.status = false
      } catch (e) {
        this.status = 'error'
        this.$tkGlobal.toast.add('加载数据失败')
      }
    },
    /**
    * 监听页面滚动改变头部背景颜色
    * @date: 2020/3/26
    */
    watchScroll (scrollTop) {
      this.isHeaderColor = scrollTop > 12
      this.$forceUpdate()
    },
    /**
     * 页面错误时点击重新加载按钮 @resetInfiniteScroll
     * @date: 2020/3/24
     */
    async refreshInit () {
      this.recommendedProductsData = []
      await this.getInit()
      this.$refs.resetInfiniteScrollHome.resetInfiniteScroll()
    },
    /**
    * 获取当前切换轮播图的索引
    * @prams {index}
    * @date: 2020/3/31
    */
    changeIndex (index) {
      this.bannerIndex = index
    },
    async getEventPictures () {
      let res = await this.$tkAjax.get('https://cloud.dianpei.mokekeji.com/settings/eventPictures').catch(e => {
        return { data: null }
      })
      if (res.data) { this.eventPictures = res.data } else { this.eventPictures = null }
    },
    /**
    * 获取轮播图数据
    * @date: 2020/3/13
    */
    async getBannerImage () {
      let bannerImage = await this.$tkParse.getList(`/classes/bannerImage`, {
        params: {
          limit: 10,
          order: '-createdAt'
        }
      })
      if (bannerImage.length) { this.bannerImage = bannerImage } else { this.bannerImage = [] }
    },
    /**
    * 金刚区功能分类数据获取
    * @date: 2020/3/13
    */
    async getKingKongDistrict () {
      let kingKongDistrict = await this.$tkParse.getList(`/classes/kingKongDistrict`, {
        params: {
          order: 'orderIndex'
        }
      })
      if (this.isUpShelf) {
        kingKongDistrict = kingKongDistrict.filter(s => {
          return s.name !== '购买推荐' && s.name !== '经营案例' && s.name !== '产业资讯'
        })
      }
      if (kingKongDistrict.length) {
        if (this.isCountyAccount) {
          this.kingKongDistrict = kingKongDistrict.filter(s => {
            return s.functionType !== 'mySales' && s.functionType !== 'myClient'
          })
        } else {
          this.kingKongDistrict = kingKongDistrict.filter(s => {
            return s.functionType !== 'checkPage' && s.functionType !== 'birthdayWishes'
          })
        }
      } else { this.kingKongDistrict = [] }
    },
    /**
    * 限时抢购数据获取
    * @date: 2020/3/20
    */
    async getLimitedTimeSnapping () {
      let limitedTimeSnapping = await this.$tkParse.getList(`/classes/commodity`, {
        params: {
          limit: 6,
          // order: '-createdAt',
          order: 'weight,-updatedAt',
          where: {
            shelvesStatus: 'shelves',
            typeActivity: 'panicBuying'
          }
        }
      })
      if (limitedTimeSnapping.length && this.judgeTimeRule) {
        this.limitedTimeSnapping = limitedTimeSnapping.map(s => {
          if (this.isTerminalAccount) {
            s.oldPrice = s.terminalPrice
            s.price = s.activityTerminalPrice
          } else {
            s.oldPrice = s.countyPrice
            s.price = s.activityCountyPrice
          }
          return s
        })
      } else { this.limitedTimeSnapping = [] }
    },
    /**
     * 限时抢购时间获取
     * @date: 2020/3/20
     */
    async getLimitedTimeRule () {
      let isoStartDate = new Date().toISOString()
      let startTime = await this.$tkAjax.get('https://cloud.dianpei.mokekeji.com/settings/startTime').catch(e => {
        return { data: null }
      })
      let endTime = await this.$tkAjax.get('https://cloud.dianpei.mokekeji.com/settings/endTime').catch(e => {
        return { data: null }
      })
      // 判断时间是否存在
      if (!startTime.data || !endTime.data) {
        this.timeRule = null
        return
      }
      let startSum = new Date(startTime.data).getTime()
      let nowSum = new Date(isoStartDate).getTime()
      if (nowSum <= startSum) {
        this.timeRule = null
        return
      }
      this.timeRule = {
        startTime: startTime.data,
        endTime: endTime.data
      }
    },
    /**
     * 品牌专场类别数据获取
     * @date: 2020/3/20
     */
    async getBrandSpecial () {
      let brandSpecial = await this.$tkParse.getList(`/classes/brandSpecial`, {
        params: {
          limit: 4,
          include: ['category'],
          order: 'updatedAt'
        }
      })
      if (brandSpecial.length) {
        this.brandSpecial = brandSpecial.map((s, index) => {
          if (index === 0) {
            s.color = 'rgba(239, 87, 134, 1)'
            s.exColor = 'rgba(239, 87, 134, 0.6)'
            s.bgImage = 'https://s3.moke.cloud/dianpei/af570d28-9c85-48ad-9b1d-0615ca32a4e3.png'
            s.tipsImage = 'https://s3.moke.cloud/dianpei/3ffbbcd4-6169-4d39-93f0-5bdec3622e7b.png'
          }
          if (index === 1) {
            s.color = 'rgba(73, 141, 253, 1)'
            s.exColor = 'rgba(73, 141, 253, 0.6)'
            s.bgImage = 'https://s3.moke.cloud/dianpei/ddfb6527-3b24-4e8d-a0b5-ec6507bab382.png'
            s.tipsImage = 'https://s3.moke.cloud/dianpei/9f28a45e-1582-4a50-ba9d-420d164e842c.png'
          }
          if (index === 2) {
            s.color = 'rgba(244, 120, 79, 1)'
            s.exColor = 'rgba(244, 120, 79, 0.6)'
            s.bgImage = 'https://s3.moke.cloud/dianpei/2de86248-7567-4619-8e3c-d43c3960a562.png'
            s.tipsImage = 'https://s3.moke.cloud/dianpei/1c0638ee-f1f8-4815-83dd-f5b999db9ac5.png'
          }
          if (index === 3) {
            s.color = 'rgba(146, 93, 252, 1)'
            s.exColor = 'rgba(146, 93, 252, 0.6)'
            s.bgImage = 'https://s3.moke.cloud/dianpei/31ee58ad-936b-42af-8c41-99250cfde422.png'
            s.tipsImage = 'https://s3.moke.cloud/dianpei/d199f07e-5894-4627-9757-348cea90b57a.png'
          }
          return s
        })
      } else {
        this.brandSpecial = []
      }
    },
    /**
     * 新品上市数据获取
     * @date: 2020/3/20
     */
    async getNewProducts () {
      let newProducts = await this.$tkParse.getList(`/classes/commodity`, {
        params: {
          limit: 6,
          // order: '-createdAt',
          order: 'weight,-updatedAt',
          where: {
            shelvesStatus: 'shelves'
          }
        }
      })
      if (newProducts.length) { this.newProducts = priceProcessing(newProducts, this.judgeTimeRule) } else { this.newProducts = [] }
    },
    /**
     * 热卖榜单数据获取
     * @date: 2020/3/20
     */
    async getHotList () {
      let hotList = await this.$tkParse.getList(`/classes/commodity`, {
        params: {
          limit: 3,
          order: '-sales',
          where: {
            shelvesStatus: 'shelves'
          }
        }
      })
      if (hotList.length) {
        this.hotList = priceProcessing(hotList.map((s, index) => {
          if (index === 0) { s.tipsImage = 'https://s3.moke.cloud/dianpei/463880e6-1a76-4f8f-9caa-6e1eeab58c57.png' }
          if (index === 1) { s.tipsImage = 'https://s3.moke.cloud/dianpei/6d1ebd6d-a0e0-465b-82ea-69e2627a6556.png' }
          if (index === 2) { s.tipsImage = 'https://s3.moke.cloud/dianpei/13f550d9-30f5-4c5f-8536-4300f8bc8880.png' }
          return s
        }), this.judgeTimeRule)
      } else {
        this.hotList = []
      }
    },
    /**
     * 促销礼品类别Id数据获取
     * @date: 2020/3/20
     */
    // async getGiftsClassId () {
    //   let className = await this.$tkParse.getList(`/classes/secondaryClassification`, {
    //     params: {
    //       limit: 1,
    //       where: {
    //         name: '促销礼品'
    //       }
    //     }
    //   })
    //   return className.length ? className[0].objectId : null
    // },
    /**
     * 促销礼品数据获取
     * @date: 2020/3/20
     */
    async getPromotionalGifts () {
      let id = '80dkpxb8rC'
      if (id) {
        let promotionalGifts = await this.$tkParse.getList(`/classes/commodity`, {
          params: {
            limit: 6,
            // order: '-createdAt',
            order: 'weight',
            where: { category: id, shelvesStatus: 'shelves' }
          }
        })
        if (promotionalGifts.length) { this.promotionalGifts = priceProcessing(promotionalGifts, this.judgeTimeRule) } else { this.promotionalGifts = [] }
      } else {
        this.promotionalGifts = []
      }
    },
    /**
     * 购买文章推荐数据获取
     * @date: 2020/3/20
     */
    async getPurchaseArticle () {
      let buyRecommendation = await this.$tkParse.getList(`/classes/buyRecommendation`, {
        params: {
          limit: 3,
          order: '-createdAt'
        }
      })
      if (buyRecommendation.length) { this.buyRecommendation = buyRecommendation } else { this.buyRecommendation = [] }
    },
    /**
    * 获取html中的文字
    * @date: 2020/3/23
    */
    getArticleText (html) {
      // return html.replace(/<\/?(img)[^>]*>/gi, '')
      let value = html.replace(/<\/?(img)[^>]*>/gi, '')
      let reg = /[\u4e00-\u9fa5]/g
      let names = value.match(reg)
      let val = names.join('')
      if (val.length > 30) {
        return val.substring(0, 30) + '...'
      }
      return val
    },
    /**
     * 获取html中的图片
     * @date: 2020/3/23
     */
    getArticleImage (str) {
      let list = []
      str.replace(/<img [^>]*src=['"]([^'"]+)[^>]*>/g,
        function (
          match,
          capture
        ) {
          list.push(capture)
        })
      if (!list.length) { return [''] }
      return list
    },
    /**
    * 为你推荐数据获取
    * @date: 2020/3/24
    */
    async recommendedProducts (page, next) {
      let commodityData = await this.$tkParse.getList(`/classes/commodity`, {
        params: {
          limit: 10,
          skip: page * 10,
          order: '-sales',
          where: {
            shelvesStatus: 'shelves'
          }
        }
      })
      this.recommendedProductsData = [...this.recommendedProductsData, ...commodityData]
      if (commodityData.length < 10) {
        next('complete')
      } else {
        next('+1')
      }
    },
    /**
    * 工具转换
    * @date: 2020/4/10
    */
    getPriceProcessing (arr, rule) {
      return priceProcessing(arr, rule)
    },
    /**
    * 金刚区分类跳转页面路由
    * @date: 2020/3/27
    */
    async toggleClass (s) {
      if (s.functionType === 'newProductsMarket') { this.$push('/commodity/newProductsMarket') }
      if (s.functionType === 'hotList') { this.$push('/commodity/hotList') }
      if (s.functionType === 'promotionalGifts') { this.$push('/commodity/promotionalGifts') }
      if (s.functionType === 'buyRecommendation') { this.$push({ path: '/common/articlePage', query: { type: 'buyRecommendation' } }) }
      if (s.functionType === 'promotions') { this.$push('/activity/promotions') }
      if (s.functionType === 'checkPage') { this.$push('/signLottery/checkPage') }
      if (s.functionType === 'birthdayWishes') { this.$push('/birthday/birthdayWishes') }
      if (s.functionType === 'mySales') { this.$push('/itsMine/mySales') }
      if (s.functionType === 'myClient') { this.$push('/itsMine/myClient') }
      if (s.functionType === 'excellentCases') { this.$push({ path: '/common/articlePage', query: { type: 'excellentCases' } }) }
      if (s.functionType === 'downLoad') { this.$push('/downLoad/downLoad') }
      if (s.functionType === 'news') { this.$push({ path: '/common/articlePage', query: { type: 'news' } }) }
    },
    /**
     * @Description: 更新消息提示
     * @author xiaozan
     * @date 2020/5/6
     */
    async getUpdateMessage () {
      if (!this.userInfo) { return } // 用户未登录截止
      let messages = await this.$tkParse.getList(`/classes/messageNotification`, {
        params: {
          limit: 1,
          order: '-createdAt',
          where: {
            userRecords: {
              $nin: [this.userInfo.objectId]
            }
          }
        }
      }).catch(() => { clearInterval(this.messageTimer) })
      let obj = {}
      if (!messages.length) { // 没有新消息
        obj.tipsStatus = {
          redShow: false
        }
      }
      if (messages.length) {
        obj.tipsStatus = {
          redShow: true
        }
      }
      await this.$store.dispatch('updateUserMsg', obj)
    }
  }
}
</script>

<style scoped lang="scss">
  /*盒子样式*/
  .container-wrap {
    width: 100%;
    height: 100%;
  }
  /*头部样式*/
  .flex {
    border-bottom: none !important;
    padding: 0 15px 10px 13px !important;
    background: rgba(255, 255, 255, 0);
    position: absolute;
    top: 0;
    z-index: 10;
    .flex-header {
      .flex-header-logo {
        color: #fff;
      }
      .flex-header-search {
        height: 30px;
        line-height: 30px;
        font-size: 14px;
        color: #bbb;
        background-color: #fff;
        margin: 0 12px;
        border-radius: 15px;
        .flex-icon {
          width: 16px;height: 16px;margin-top: 8px;
        }
      }
    }
  }
  /*后台数据渲染样式*/
  .content-box {
    /*background-position: center center;*/
    background-repeat:  no-repeat;
    background-size: 100% auto;
    min-height: 500px;
    /*本地分类样式*/
    .type-box {
      .type-width {
        width: 20%;
      }
      .type-img {
        width: 49px;
        height: 49px;
      }
      .type-text {
        font-size: 11px;
        padding-top: 7px;
        padding-bottom: 5px;
        color: #212121;
      }
    }
    /*活动图片样式*/
    .event-pictures {
      width: 100%;
      height: 67px;
      overflow: hidden;
      margin-top: 7px;
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
    /*品牌专场样式*/
    .brand-special {
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
      padding: 4px 8px;
      min-height: 80px;
      overflow: hidden;
      border-radius: 5px;
    }
    /*热卖榜单样式*/
    .class-card-red { /*颜色及文本修饰*/
      color: rgba(250, 51, 51, 1);
    }
    /*提示样式*/
    .class-hot-list {
      text-align: center;
      background-position: center center;
      background-repeat:  no-repeat;
      background-size: 100% 100%;
      position: absolute;
      min-width: 24px;
      min-height: 31px;
      padding: 2px;
      font-size: 10px;
      color: #fff;
      border-radius: 5px;
      overflow: hidden;
      top: 0;
      left: 0;
    }
    /*文章图片样式*/
    .content-box-br {
      width: 100%;
      height: 0;
      padding-bottom: 100%;
      overflow: hidden;
      position: relative;
    }
    .content-box-br-img {
      border-radius: 5px;
      overflow: hidden;
      width: 100%;
      height: 100%;
      position: absolute;
    }
    .content-box-br-html {
      background-color: rgba(249, 251, 252, 1);
      border-radius: 5px;
      font-size: 14px !important;
      padding: 9px;
      width: 100%;
      overflow: hidden;
      ::v-deep p {
        span {
          font-size: 14px !important;
        }
      }
    }
    /*为你推荐样式*/
    .class-recommended {
      border-radius: 5px;
      overflow: hidden;
      .class-recommended-image {
        border-radius: 5px;
        overflow: hidden;
        width: 168px;
        height: 168px;
      }
    }
  }
</style>
